<template>
	<div class="reservation-layout">
		<div class="reservation-layout__nav-container">
			<nav v-if="isCarsCatalog" ref="navRef" class="reservation-layout__nav">
				<GlobalHeader booker />
			</nav>
			<nav v-else ref="navRef" class="reservation-layout__nav">
				<ReservationTopBar ref="reservationTopBarRef" class="reservation-layout__topbar" />
			</nav>
		</div>
		<GlobalBookerFallback nav>
			<ClientOnly>
				<LazyIdleGlobalBooker nav hydrate-on-idle />
			</ClientOnly>
		</GlobalBookerFallback>
		<main><slot /></main>
		<LazyVisibleGlobalFooter v-if="isCarsCatalog" hydrate-on-visible />
		<GlobalCallButton />
	</div>
</template>

<script setup lang="ts">
const route = useRoute()
const topBarData = ref<any[]>([])
const step = ref(0)
const reservationTopBarHeight = ref(0)
const navRef = ref<HTMLElement | null>(null)
const navHeight = ref<number | undefined>(undefined)
const localePath = useLocalePath()

const isCarsCatalog = computed(() => route.path === localePath('cars'))

onMounted(() => {
	if (navRef.value) {
		const observer = new ResizeObserver((entries) => {
			navHeight.value = entries[0].contentRect.height
		})
		observer.observe(navRef.value)
		onBeforeUnmount(() => observer.disconnect())
	}
})

provide('navHeight', navHeight)
provide('topBarData', topBarData)
provide('step', step)
provide('reservationTopBarHeight', reservationTopBarHeight)

topBarData.value = [{ title: 'select_a_vehicle', active: true, url: 'cars' }, { title: 'insurance_and_allowances' }, { title: 'booking', last: true }]

watch(
	() => step.value,
	() => {
		topBarData.value.forEach((point) => {
			point.active = false
			point.done = false
		})
		for (let i = 0; i < step.value; i++) {
			topBarData.value[i].done = true
		}
		topBarData.value[step.value].active = true
	},
	{ immediate: true },
)
</script>

<style lang="scss" scoped src="./reservation.scss"></style>
